var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWixLogo = function SvgWixLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 18,
    viewBox: "0 0 48 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wix-logo_svg__a)",
    fill: "#000624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.308 0h-2.586c-.717 0-1.387.353-1.79.943l-3.457 5.066a.233.233 0 0 1-.384 0L35.633.943A2.166 2.166 0 0 0 33.843 0h-2.585l6.159 9.025L31.292 18h2.585c.717 0 1.388-.353 1.79-.943l3.424-5.016a.233.233 0 0 1 .384 0l3.423 5.016c.402.59 1.073.943 1.79.943h2.586l-6.125-8.975L47.308 0ZM25.939 1.841V18h1.235a1.847 1.847 0 0 0 1.854-1.841V0h-1.236a1.847 1.847 0 0 0-1.854 1.841ZM23.673 0h-1.1c-1.21 0-2.26.832-2.527 2.004l-2.46 10.742-2.153-10.027A3.435 3.435 0 0 0 11.16.153C9.914.495 8.99 1.543 8.72 2.8l-2.131 9.932L4.132 2.005A2.59 2.59 0 0 0 1.604 0h-1.1l4.122 18h1.561a2.998 2.998 0 0 0 2.937-2.361l2.634-12.28a.335.335 0 0 1 .653 0l2.637 12.28A2.997 2.997 0 0 0 17.985 18h1.566L23.673 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wix-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.505)",
    d: "M0 0h47v18H0z"
  })))));
};
export default SvgWixLogo;